import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PathwayData } from '../types';
import './CoursePage.css';

const CoursePage: React.FC = () => {
  const navigate = useNavigate();
  const [pathwayData, setPathwayData] = useState<PathwayData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load demo data
    fetch('/assets/demo.json')
      .then(response => response.json())
      .then((data: PathwayData) => {
        setPathwayData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading pathway data:', error);
        setLoading(false);
      });
  }, []);

  const navigateToSemester = () => {
    navigate('/semester');
  };

  if (loading) {
    return <div className="loading">Loading pathway data...</div>;
  }

  if (!pathwayData) {
    return <div className="error">Failed to load pathway data</div>;
  }

  return (
    <div className="course-page">
      <header className="course-header">
        <div className="nav-left">
          <button onClick={() => navigate('/login')} className="nav-button secondary">
            ← Back to Login
          </button>
        </div>
        <h1>Course Planning</h1>
        <div className="navigation-buttons">
          <button onClick={navigateToSemester} className="nav-button">
            Semester Calendar →
          </button>
        </div>
      </header>

      <div className="requirements-container">
        {pathwayData.requirementGroups.map((group, groupIndex) => (
          <div key={groupIndex} className="requirement-group">
            <h2>{group.name}</h2>
            {group.requirements.map((requirement, reqIndex) => (
              <div key={reqIndex} className="requirement">
                <div className="requirement-header">
                  <h3>{requirement.name}</h3>
                  <span className={`status ${requirement.state.toLowerCase().replace(' ', '-')}`}>
                    {requirement.state}
                  </span>
                </div>
                <div className="courses-list">
                  {requirement.courses.map((course, courseIndex) => (
                    <div key={courseIndex} className="course-item">
                      <span className="course-name">{course.name}</span>
                      <span className="course-term">{course.term}</span>
                      <span className="course-grade">{course.grade}</span>
                      <span className="course-credit">{course.credit} credits</span>
                      <span className={`course-status ${typeof course.status === 'string' ? course.status.toLowerCase() : ''}`}>
                        {course.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursePage;
